import { render, staticRenderFns } from "./AdminCampaignItemPaymentTableRow.vue?vue&type=template&id=66cb91ce&scoped=true&"
import script from "./AdminCampaignItemPaymentTableRow.vue?vue&type=script&lang=ts&"
export * from "./AdminCampaignItemPaymentTableRow.vue?vue&type=script&lang=ts&"
import style0 from "./AdminCampaignItemPaymentTableRow.vue?vue&type=style&index=0&id=66cb91ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cb91ce",
  null
  
)

export default component.exports
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTd});
